export const formatearMoneda = (value: string = "") => {
    const numericValue = parseInt(value.replace(/[^0-9]/g, ""), 10);
    return `$ ${new Intl.NumberFormat("es-AR").format(numericValue)}`;
};